module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$guser.isClinic() && _vm.$guser.user.clinic && _vm.$guser.user.clinic.approved !== 1) ? _c('div', {
    staticClass: "card-inverse card-warning alert-top-box card-orange-warning"
  }, [_c('div', {
    staticClass: "card-block alert-container"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle alert-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "card-blockquote alert-text"
  }, [_c('h4', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('message.alert_bar.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar.message')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar.contact')))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic() && _vm.$guser.user.clinic && _vm.$guser.user.clinic.approved === 1 && _vm.$guser.user.clinic.sms_active && _vm.$guser.user.clinic.sms_credit < 100) ? _c('div', {
    staticClass: "card-inverse card-warning alert-top-box card-orange-warning"
  }, [_c('div', {
    staticClass: "card-block alert-container"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle alert-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "card-blockquote alert-text"
  }, [_c('h4', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('message.alert_bar_sms_warning.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar_sms_warning.message')) + " " + _vm._s(_vm.$guser.user.clinic.sms_credit + ' Credit'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar_sms_warning.contact')))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor() && _vm.$guser.user.doctor && _vm.$guser.user.doctor.approved !== 1) ? _c('div', {
    staticClass: "card-inverse card-warning alert-top-box card-orange-warning"
  }, [_c('div', {
    staticClass: "card-block alert-container"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle alert-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "card-blockquote alert-text"
  }, [_c('h4', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('message.alert_bar.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar.message')) + " " + _vm._s(_vm.$t('message.alert_bar.contact')))])])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e81cf92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlertBar.vue
// module id = 1000
// module chunks = 1